module.exports = __webpack_public_path__ + "static/media/sports-icon.9e6e8ed5.png";